<div *ngIf="!displayMobileView" class="content-table-pointer">
  <ion-row class="content" routerLink="./edit/{{ row.id }}">
    <ion-col size="1">
      <ion-item lines="none" class="rental__img-container">
        <ion-img
          class="rental__img"
          *ngIf="row.image"
          [src]="row.image.thumbnail ? row.image.thumbnail : row.image.filePath"
        >
        </ion-img>
        <ion-img
          *ngIf="!row.image"
          class="rental__img"
          src="../../../assets/icons/book-outline.svg"
        >
        </ion-img>
      </ion-item>
    </ion-col>
    <ion-col size="2">
      {{ row.name }}
    </ion-col>
    <ion-col class="rental__description" size="3">
      {{ row.description }}
    </ion-col>
    <ion-col size="2">
      <ion-label>
        <app-status
          [directionColumn]="false"
          [color]="rentalServ.getStatusColor(row.rentalStatus)"
          name="{{ 'RENTAL.STATUS.' + row.rentalStatus | translate }}"
        >
        </app-status>
      </ion-label>
    </ion-col>
    <ion-col size="2">
      {{ "RENTAL.RESERVED" | translate }}: {{ row.reservationCount }}
      <br />
      {{ "RENTAL.STATUS.RENTALS" | translate }}: {{ row.rentalsCount }}
    </ion-col>
    <ion-col size="2">
      <ion-button (click)="onClickReservation($event)">{{
        "RENTAL.BOOK" | translate
      }}</ion-button>
    </ion-col>
  </ion-row>
</div>

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder"
  routerLink="./edit/{{ row.id }}"
>
  <ion-card-header class="rental__card-header">
    <ion-grid class="ion-no-padding w-100">
      <ion-row>
        <ion-col class="ion-no-padding" size="7">
          <ion-card-title>
            {{ row.name }}
          </ion-card-title>
        </ion-col>
        <ion-col class="ion-no-padding" size="5">
          <ion-label class="rental__status">
            <app-status
              [directionColumn]="false"
              [color]="rentalServ.getStatusColor(row.rentalStatus)"
              name="{{ 'RENTAL.STATUS.' + row.rentalStatus | translate }}"
            >
            </app-status>
          </ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="9">
          <ion-card-subtitle class="rental__description">
            {{ row.description }}
          </ion-card-subtitle>
        </ion-col>
        <ion-col size="3">
          <ion-img
            class="rental__img float-right"
            [src]="
              row.image
                ? row.image.filePath
                : '../../../assets/icons/book-outline.svg'
            "
          >
          </ion-img>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-header>
  <ion-card-content>
    <div class="line-divider"></div>
    <div class="rental__counts-and-button">
      <div>
        <ion-label>
          {{ "RENTAL.RESERVATIONS_COUNT" | translate }}:
          {{ row.reservationCount }}
        </ion-label>
        <br />
        <ion-label>
          {{ "RENTAL.RENTALS_COUNT" | translate }}: {{ row.rentalsCount }}
        </ion-label>
      </div>
      <ion-button (click)="onClickReservation($event)">
        {{ "RENTAL.BOOK" | translate }}
      </ion-button>
    </div>
  </ion-card-content>
</ion-card>
